import { Space, Typography, YesNo } from "components/styleguide";
import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface ShowBedroomSelectOptionProps {
  showBedroom: boolean;
  setShowBedroom: Dispatch<SetStateAction<boolean>>;
}

const ShowBedroomSelectOption = ({ showBedroom, setShowBedroom }: ShowBedroomSelectOptionProps) => {
  const { t } = useTranslation();

  return (
    <Space direction={"vertical"}>
      <Typography.Text>{t("Show Bedroom")}</Typography.Text>
      <YesNo style={{ width: "200px" }} value={showBedroom} onSelect={setShowBedroom} />
    </Space>
  );
};

export default ShowBedroomSelectOption;
